import { connect } from 'react-redux';

import {
  fetchCartInfo,
  setCartInfo,
  rewardPointsApplied,
  rewardPointsRemoved,
  addItemToWishlist,
  removeItem,
  itemQuantityUpdate,
  setToastMessage,
  getFreeSamples,
} from '@nykaa/cart-shared/store/action';

import { State } from 'store/types';
import ShoppingBag from 'layouts/ShoppingBag';

const mapStateToProps = (state: State) => {
  const { auth, cartReducer } = state;
  return {
    formKey: auth.user.formKey,
    cartInfo: cartReducer.cartInfo,
    loading: cartReducer.loading,
    shoppingBagError: cartReducer.error,
    toastMsg: cartReducer.toastMessage,
    freeSamples: cartReducer.freeSamples,
  };
};

const mapDispatchToProps = {
  fetchCartInfo,
  setCartInfo,
  rewardPointsApplied,
  rewardPointsRemoved,
  addItemToWishlist,
  removeItem,
  itemQuantityUpdate,
  setToastMessage,
  getFreeSamples,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingBag);
